module.exports = __webpack_public_path__ + "img/ugo.9fa2235d.jpg";